// extracted by mini-css-extract-plugin
export default {"backgroundImage":"VO","content":"WO","rtbLeft":"XO","rtbRight":"YO","rtbLeftMobile":"ZO","imageContainer":"aP","rtbBox":"bP","line":"cP","rtbDesktop":"eP"};
    if(module.hot) {
      // 1715632478441
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  